const NotFound = () => {
    return (
        <div>
            <span>{'Not found!'}</span>
        </div>
    )
}
export default NotFound
